import { useNavigate, useParams } from 'react-router-dom';
import SelectorSemana from '../../Componentes/CalendarioSemanal/SelectorSemana';
import CalendarioSemanalTabla from '../../Componentes/CalendarioSemanal/CalendarioSemanalTabla';
import { startOfWeek, addWeeks } from 'date-fns';
import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase'; // Asegúrate de tener esto bien importado

const CalendarioSemanal = () => {

  const { hubId } = useParams(); // ← obtiene el ID de la URL
  const [desplazamientoSemanas, setDesplazamientoSemanas] = useState(0);
  const [listaEmpresas, setListaEmpresas] = useState([]);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState('');
  const navigate = useNavigate(); // para el botón de volver atrás

  const lunesActual = startOfWeek(new Date(), { weekStartsOn: 1 });
  const lunesSeleccionado = addWeeks(lunesActual, desplazamientoSemanas);

  useEffect(() => {
    const cargarEmpresas = async () => {
      if (!hubId) return;

      const empresasRef = collection(db, 'private-hubs', hubId, 'Empresas');
      const snapshot = await getDocs(empresasRef);
      const lista = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setListaEmpresas(lista);

      // Seleccionar la primera empresa si no hay ninguna seleccionada
      if (lista.length > 0 && !empresaSeleccionada) {
        setEmpresaSeleccionada(lista[0].id);
      }
    };

    cargarEmpresas();
  }, [hubId, empresaSeleccionada]);


  


  return (
    <div className="lobby-container">
        {/* Header */}
        <div className="header-container">
        <header className="header">
            <h1 className="header-title">Calendario Semanal</h1>
            <div className='logout-button-container'>
            <button onClick={() => navigate(-1)} className="logout-button">
                ← Volver
            </button>
            </div>
        </header>
        </div>

        {/* Contenido principal */}
        <div className="calendar-box data-box p-6 max-w-7xl mx-auto" style={{ padding: '20px' }}>

        <div style={{ marginBottom: '20px' }}>
          <label className="labelText">Selecciona un restaurante:</label>
          <select
            value={empresaSeleccionada}
            onChange={e => setEmpresaSeleccionada(e.target.value)}
            className="labelText"
            style={{ padding: '6px 12px', fontSize: '1rem' }}
          >
            {listaEmpresas.map((empresa) => (
              <option key={empresa.id} value={empresa.id}>
                {empresa.nombre}
              </option>
            ))}
          </select>
        </div>


        <SelectorSemana
            desplazamientoSemanas={desplazamientoSemanas}
            setDesplazamientoSemanas={setDesplazamientoSemanas}
            lunesSeleccionado={lunesSeleccionado}
        />

        {empresaSeleccionada && (
          <CalendarioSemanalTabla
            lunesSeleccionado={lunesSeleccionado}
            hubId={hubId}
            empresaId={empresaSeleccionada}
          />
        )}
        </div>

    </div>
  );
};

export default CalendarioSemanal;
